module.exports = __webpack_public_path__ + "img/image (5).9ff0fe33.png";